var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 41.9998L0.000117183 1.74978L1.44409 0.365967L43.444 40.616L42 41.9998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.24482e-05 40.25L41.9999 -2.34842e-05L43.4438 1.38379L1.44392 41.6338L-5.24482e-05 40.25Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0NCA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQyIDQxLjk5OThMMC4wMDAxMTcxODMgMS43NDk3OEwxLjQ0NDA5IDAuMzY1OTY3TDQzLjQ0NCA0MC42MTZMNDIgNDEuOTk5OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNLTUuMjQ0ODJlLTA1IDQwLjI1TDQxLjk5OTkgLTIuMzQ4NDJlLTA1TDQzLjQ0MzggMS4zODM3OUwxLjQ0MzkyIDQxLjYzMzhMLTUuMjQ0ODJlLTA1IDQwLjI1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { ForwardRef as ReactComponent };